<template>
  <v-dialog v-model="is_SendOrderProductModal" max-width="1000px">
    <v-card class="send-order-product-setting">
      <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold">주문 상태별 발송 - 주문 상품 설정하기</v-card-title>
      <v-card-text class="pl-5 pb-0">
        주문 연동시 해당 설정을 기준으로 주문 상품을 체크하여 발송 처리가 됩니다.<br />
        판매되는 모든 정품(카페24 상품)에 시리얼 코드 매칭하여 생성/등록하여 사용하는 경우 ‘시리얼 코드 생성한 상품’을 선택해주세요.<br />
        임의의 카페24 상품을 만들어 시리얼 코드를 생성, 고객에게 랜덤으로 시리얼 코드를 전달하여 정품 인증을 사용하는 경우 <br />
        ‘개별 상품 설정’을 통해 실제 정품으로 체크할 상품을 선택해주세요.<br />
        쇼핑몰에 판매되는 상품 전체가 정품 인증 상품인 경우에는 ‘모든 주문 상품’을 선택하여 사용하실 수 있습니다.
      </v-card-text>
      <v-card-text class="mt-8">
        <div class="subtitle-1 font-weight-bold black--text">주문 상품 체크 설정</div>
        <v-radio-group v-model="sending_product_type" row hide-details class="text-mid selected-radio pb-4">
          <v-radio class="mr-10" label="시리얼 코드 생성한 상품" value="cert_product"></v-radio>
          <v-radio class="mr-10" label="개별 상품 설정" value="product_config"></v-radio>
          <v-radio class="mr-10" label="모든 주문 상품" value="all_order"></v-radio>
        </v-radio-group>
        <v-row v-if="sending_product_type == 'product_config'">
          <v-col cols="6">
            <v-card-subtitle class="pb-0 font-weight-bold pl-0 mb-2 black--text">
              카페24 상품 조회/선택
            </v-card-subtitle>
            <div class="d-flex justify-space-between">
              <v-select
                v-model="searchPayload.search_type"
                :items="search_type_list"
                outlined
                dense
                hide-details="false"
                hint="상품을 선택해주세요."
                class="mr-2"
              ></v-select>
              <v-text-field
                v-model="searchPayload.search_value"
                outlined
                dense
                hide-details="false"
                class="mr-2"
                @keypress.enter="searchProduct"
                placeholder="검색어 입력"
              ></v-text-field>
              <v-btn color="grey darken-4" height="40px" class="white--text" @click="searchProduct">조회</v-btn>
            </div>
            <div class="rounded-lg mt-4 product_list py-0">
              <v-list dense class="py-0">
                <v-list-item class="d-flex justify-space-between text-center list-border-bottom">
                  <v-list-item-title :style="{ width: '80%' }" class="table-title">상품 정보</v-list-item-title>
                  <v-list-item-title :style="{ width: '20%' }" class="table-title"> 선택 </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-for="(item, index) in search_product_list"
                  :key="index"
                  class="d-flex justify-space-between list-border-bottom"
                >
                  <v-list-item-avatar rounded="false">
                    <v-img v-if="item.list_image" :src="item.list_image" width="40" height="40"></v-img>
                    <v-img v-else :src="adminDefaultImg" width="40" height="40"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      [{{ item.product_code }}] {{ item.product_name }}<br />
                      판매가 : {{ item.product_price | numberFormat }}원
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn color="blue darken-1" class="white--text" small @click="addSelectProduct(item.product_code)">설정</v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </v-col>
          <v-col cols="6">
            <v-card-subtitle class="pb-2 font-weight-bold black--text pl-0">
              설정 상품 목록
            </v-card-subtitle>
            <div class="d-flex justify-space-between align-center " :style="{ height: '40px' }">
              <span>
                총 설정 <span class="blue--text">{{ selected_product_list.length }}</span> 개
              </span>
              <v-btn color="blue-grey darken-3" class="white--text" small @click="unselectAllProduct">전체삭제</v-btn>
            </div>
            <div class="rounded-lg mt-4 product_list">
              <v-list dense class="py-0">
                <v-list-item class="text-center list-border-bottom">
                  <v-list-item-title :style="{ width: '80%' }" class="table-title">상품 정보</v-list-item-title>
                  <v-list-item-title :style="{ width: '20%' }" class="table-title"> 삭제 </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-for="(item, index) in selected_product_list"
                  :key="index"
                  class="d-flex justify-space-between list-border-bottom"
                >
                  <v-list-item-avatar rounded="false">
                    <v-img v-if="item.product_image" :src="item.product_image" width="40" height="40"></v-img>
                    <v-img v-else :src="adminDefaultImg" width="40" height="40"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      [{{ item.product_code }}] {{ item.product_name }}<br />
                      판매가 : {{ item.product_price | numberFormat }}원
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn color="grey darken-1" class="white--text" small @click="removeSelectProduct(item.product_code)">삭제</v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-space-between mt-5 pa-0">
          <div style="width:49%;">
            <v-btn color="grey darken-4" block class="white--text" @click="is_SendOrderProductModal = false">닫기</v-btn>
          </div>
          <div style="width:49%;">
            <v-btn color="blue darken-1" block class="white--text" @click="setSendProduct">저장하기</v-btn>
          </div>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>
.send-order-product-setting .selected-radio {
  font-size: 15px;
}

.send-order-product-setting .product_list {
  height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.send-order-product-setting .product_list .v-list-item {
  flex: auto;
}

.send-order-product-setting .product_list .v-avatar {
  border-radius: 2px;
}

.send-order-product-setting .list-border-bottom {
  border-bottom: 1px solid #e0e0e0;
}

.send-order-product-setting label {
  font-size: unset !important;
}
</style>

<script>
import M from "@/libs/mapping.js";
import Filters from "@/libs/authservice/filters.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      is_SendOrderProductModal: false,
      sending_product_type: "all_order",
      search_type_list: [
        { text: "상품명", value: "product_name" },
        { text: "상품코드", value: "product_code" },
      ],
      searchPayload: {
        search_type: "product_name",
        search_value: "",
      },
      search_product_list: [],
      selected_product_list: [],
      adminDefaultImg: require("@/assets/authservice/images/admin_default.png"),
    };
  },
  created: function() {
    // get setting info  API Call
  },
  mixins: [CommonMixin],
  methods: {
    getConfigOrderProduct: async function() {
      let data = await M.api(M.entry("/get/config/order/product"));
      if (data) {
        this.sending_product_type = data.sending_product_type;
        this.selected_product_list = data.product_list;
      }
    },
    addSelectProduct(product_code) {
      const select_item = this.search_product_list.find((item) => item.product_code == product_code);
      this.selected_product_list.push({
        ...select_item,
        product_image: select_item.list_image,
      });
      // console.log("check search_product", this.search_product_list);
      this.search_product_list = this.search_product_list.filter((item) => item.product_code != product_code);
      this.alertShow(product_code + "선택한 상품을 선택하였습니다.");
      // console.log("chk list", this.selected_product_list);
    },
    removeSelectProduct(product_code) {
      this.selected_product_list = this.selected_product_list.filter((item) => item.product_code != product_code);
    },
    getProductList: async function(payload) {
      let data = await M.api(M.entry("/get/search/product"), payload);
      this.search_product_list =
        data
          .map((item) => ({
            ...item,
            product_name: item.product_name.replace(/<\/?[^>]+(>|$)/g, ""), // Remove HTML tags from product_name
          }))
          .filter((item) => !this.selected_product_list.some((selected) => selected.product_code === item.product_code)) || [];
      this.defaultProgressHide();
    },
    searchProduct() {
      if (this.searchPayload.search_type === "product_name" && this.searchPayload.search_value.length < 3) {
        this.alertShow("상품명은 3글자 이상부터 검색이 가능합니다.");
        return;
      }
      this.defaultProgressShow();
      this.getProductList(this.searchPayload);
    },
    unselectAllProduct() {
      if (confirm("설정하신 상품 목록을 전체 삭제 하시겠습니까?")) {
        this.selected_product_list = [];
      }
    },
    openSendOrderProductModal() {
      // console.log("open searchopen product modal");
      this.getConfigOrderProduct();
      this.search_product_list = [];
      this.searchPayload.search_value = "";
      this.is_SendOrderProductModal = true;
    },
    async setSendProduct() {
      //this.$emit("changeUseSetting", this.switchValue);
      try {
        const res = M.api(M.entry("/put/config/order/product"), {
          sending_product_type: this.sending_product_type,
          product_list: this.selected_product_list,
        });
        console.log("set order product result", res);
        this.alertShow("주문 상품 설정이 저장되었습니다.");
        this.is_SendOrderProductModal = false;
      } catch (error) {
        console.log(error);
        this.alertShow("주문 상품 설정 저장에 실패하였습니다.");
      }
    },
  },
  filters: Filters,
};
</script>
